import { Subject } from 'rxjs';

class PaymentSelectionService {
    static selectedPaymentMethod$ = new Subject();
}

export default PaymentSelectionService;



/** WEBPACK FOOTER **
 ** ./src/services/payment-selection-service.js
 **/